import { useState } from "react";

import Circle from "../LogoSVG/Circle";

export const TADesktop = () => {
  return (
    <div className="flex flex-row items-start mb-[0px]">
      <div className="flex flex-col justify-start">
        <div className="mb-2 text-[18px]  flex flex-row items-center">
          <div className="font-medium mr-2">
            Graduate Teaching Assistant - University of Calgary |
          </div>
          <div className=" text-gray-4">Sep 2025 - Present</div>
        </div>
        <ul className="text-gray-5">
          <li>
            <div className="flex flex-row ">
              {/* <Circle className="mr-3 h-1.5 w-1.5 mt-2" /> */}
              <p className="text-gray-4">
                SENG 401: Software Architecture (Winter '26)
              </p>
            </div>
          </li>

          <li>
            <div className="flex flex-row items-start mt-1.5">
              {/* <Circle className="mr-3 h-1.5 w-1.5 mt-2" /> */}
              <div className="text-gray-4 w-[600px]">
                SENG 533: Software Performance Evaluation (Winter '26)
              </div>
            </div>
          </li>

          <li>
            <div className="flex flex-row items-start mt-1.5">
              {/* <Circle className="mr-3 h-1.5 w-1.5 mt-2" /> */}
              <div className="text-gray-4 w-[600px]">
                ENCM 335: Programming Fundamentals (Fall '25, '26)
              </div>
            </div>
          </li>

          <li>
            <div className="flex flex-row items-start mt-1.5">
              {/* <Circle className="mr-3 h-1.5 w-1.5 mt-2" /> */}
              <div className="text-gray-4 w-[600px]">
                ENDG 233: Programming with Data (Fall '26)
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};
